export { PressReleaseSnippet } from '@/components/common/PressReleaseSnippet/PressReleaseSnippet';
